<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <div class="card-header card-header-primary negative blue-grad w-50">
              <search-help-text class="pb-1"></search-help-text>
              <h4 class="card-title">
                {{ $t("message.find_partner.common_info_cn")
                }}<span v-if="doc_additional && doc_additional.request"
                  >: {{ doc_additional.request }}</span
                >
              </h4>
            </div>
            <table class="table" style="width: 100%">
              <thead>
                <tr>
                  <th scope="col">
                    {{ $t("message.find_partner.table_field") }}
                  </th>
                  <th scope="col">
                    {{ $t("message.find_partner.table_value") }}
                  </th>
                  <th scope="col">
                    {{ $t("message.find_partner.table_value_cn") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, index) in this.doc.service_info" v-if="value[0] !== 'OperId' &&
                        value[0] !== 'KeyNo' &&
                        value[0] !== 'CreditCode' &&
                        value[0] !== 'RevokeInfo' &&
                        value[0] !== 'ParentInfo'">   
                      <td style="max-width: 150px">
                        {{ $t("message.find_partner.common_info_" + value[0]) }}
                      </td>
                      <td v-if="value[0] == 'ImageUrl'">
                        <img :src="value[2]" :alt="value[2]" style="max-width: 100px" />
                      </td>
                      <td v-if="value[0] == 'ImageUrl'">
                        <img :src="value[2]" :alt="value[2]" style="max-width: 100px" />
                      </td>
                      <td v-if="value[0] == 'WebSiteUrl'">
                        <a target="_blank" :href="prepareURL(value[2])">{{
                          $t("message.find_partner.visit_company_website")
                        }}</a>
                      </td>
                      <td v-if="value[0] == 'WebSiteUrl'">
                        <a target="_blank" :href="prepareURL(value[2])">{{
                          $t("message.find_partner.visit_company_website")
                        }}</a>
                      </td>
                      <td
                        v-if="value[0] !== 'WebSiteUrl' && value[0] !== 'ImageUrl'"
                        style="max-width: 150px"
                      >
                        {{ value[2] }}

                        <p v-if="value[0] === 'IXCode'">
                          <br/>
                          {{ $t("message.find_partner.common_info_IXCode_description") }}
                        </p>
                      </td>
                      <td
                        v-if="value[0] !== 'WebSiteUrl' && value[0] !== 'ImageUrl'"
                        style="max-width: 150px"
                      >
                        {{ value[1] }}
                      </td>
                    </tr>
                    <tr
                      v-for="(value, index) in this.doc.service_info"
                      v-if="value[0] == 'CreditCode'"
                    >
                      <td style="max-width: 150px">
                        {{ $t("message.find_partner.common_info_" + value[0]) }}
                      </td>
                      <td style="max-width: 150px">{{ value[1] }}</td>
                      <td style="max-width: 150px">{{ value[1] }}</td>
                    </tr>
              </tbody>
            </table>

            <div v-if="doc.response_info.Area">
              <div
                class="card-header card-header-primary negative blue-grad w-50"
              >
                <h4>{{ $t("message.find_partner.area_table") }}</h4>
              </div>
              <br />
              <b-table :fields="object_table_fields" :items="doc.areaList">
                <template v-slot:cell(Key)="data">
                {{ $t("message.find_partner.area_list_" + data.value) }}
              </template>
              </b-table>
            </div>

            <div v-if="doc.response_info.Industry">
              <div
                class="card-header card-header-primary negative blue-grad w-50"
              >
                <h4>{{ $t("message.find_partner.industry_table") }}</h4>
              </div>
              <br />
              <b-table :fields="object_table_fields" :items="doc.industryList">
                <template v-slot:cell(Key)="data">
                  {{ $t("message.find_partner.industry_list_" + data.value) }}
                </template>
              </b-table>
            </div>
            <div v-if="doc.response_info.RevokeInfo">
              <div
                class="card-header card-header-primary negative blue-grad w-50"
              >
                <h4>{{ $t("message.find_partner.revoke_info_table") }}</h4>
              </div>
              <br />
              <b-table
                :fields="object_table_fields"
                :items="doc.revokeInfoList"
              >
                <template v-slot:cell(Key)="data">
                  {{ $t("message.find_partner.revoke_info_list_" + data.value) }}
                </template>
              </b-table>
            </div>
            <div v-if="doc.response_info.ParentInfo">
              <div
                class="card-header card-header-primary negative blue-grad w-50"
              >
                <h4>{{ $t("message.find_partner.parent_info_table") }}</h4>
              </div>
              <br />
              <b-table
                :fields="object_table_fields"
                :items="doc.parentInfoList"
              >
                <template v-slot:cell(Key)="data">
                      {{
                        $t("message.find_partner.parent_info_list_" + data.value)
                      }}
                </template>
              </b-table>
            </div>

            <div v-if="doc.UsedNameList.length > 0">
              <div
                class="card-header card-header-primary negative blue-grad w-50"
              >
                <h4>{{ $t("message.find_partner.common_info_name_list") }}</h4>
              </div>
              <br />
              <b-table
                :fields="used_name_list_fields"
                :items="doc.UsedNameList"
              >
              </b-table>
            </div>

            <div v-if="doc.ShareHolderList.length > 0">
              <div
                class="card-header card-header-primary negative blue-grad w-50"
              >
                <h4>
                  {{ $t("message.find_partner.common_info_share_holder_list") }}
                </h4>
              </div>
              <br />
              <b-table
                :fields="shareholder_list_fields"
                :items="doc.ShareHolderList"
              >
              </b-table>
            </div>

            <div v-if="doc.EmployeeList.length > 0">
              <div
                class="card-header card-header-primary negative blue-grad w-50"
              >
                <h4>
                  {{ $t("message.find_partner.common_info_employee_list") }}
                </h4>
              </div>
              <br />
              <b-table
                :fields="employees_list_fields"
                :items="doc.EmployeeList"
              >
              </b-table>
            </div>

            <div v-if="doc.InvestList.length > 0">
              <div
                class="card-header card-header-primary negative blue-grad w-50"
              >
                <h4>
                  {{ $t("message.find_partner.common_info_invest_list") }}
                </h4>
              </div>
              <br />
              <b-table :fields="invest_list_fields" :items="doc.InvestList">
              </b-table>
            </div>
            <div v-if="doc.ChangeList.length > 0">
              <div
                class="card-header card-header-primary negative blue-grad w-50"
              >
                <h4>
                  {{ $t("message.find_partner.common_info_change_list") }}
                </h4>
              </div>
              <br />
              <b-table :fields="change_list_fields" :items="doc.ChangeList">
              </b-table>
            </div>
            <div v-if="doc.BranchList.length > 0">
              <div
                class="card-header card-header-primary negative blue-grad w-50"
              >
                <h4>
                  {{ $t("message.find_partner.common_info_branch_list") }}
                </h4>
              </div>
              <br />
              <b-table :fields="branch_list_fields" :items="doc.BranchList">
              </b-table>
            </div>
            <div v-if="doc.MoreEmailList.length > 0">
              <div
                class="card-header card-header-primary negative blue-grad w-50"
              >
                <h4>
                  {{ $t("message.find_partner.common_info_more_email_list") }}
                </h4>
              </div>
              <br />
              <b-table
                :fields="more_email_list_fields"
                :items="doc.MoreEmailList"
              >
              </b-table>
            </div>
            <div v-if="doc.EntTagList.length > 0">
              <div
                class="card-header card-header-primary negative blue-grad w-50"
              >
                <h4>
                  {{ $t("message.find_partner.common_info_ent_tag_list") }}
                </h4>
              </div>
              <br />
              <b-table :fields="ent_tag_list_fields" :items="doc.EntTagList">
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: ["user_id", "doc_id", "doc", "goods", "doc_additional"],
  data() {
    return {
      current_tab: 0,
      response_info: {},
      service_info: {},
      service_info_objects: {},
      keyWord: "",
      searchComplete: false,
      used_name_list_fields: [
        {
          key: "Name",
          label: this.$t("message.find_partner.common_info_name_list_name"),
        },
        {
          key: "ChangeDate",
          label: this.$t("message.find_partner.common_info_name_list_date"),
        },
      ],
      shareholder_list_fields: [
        // {
        //   key: "KeyNo",
        //   label: this.$t("message.find_partner.common_info_share_holder_KeyNo"),
        // },
        {
          key: "StockName",
          label: this.$t(
            "message.find_partner.common_info_share_holder_StockName",
          ),
        },
      ],
      employees_list_fields: [
        // {
        //   key: "KeyNo",
        //   label: this.$t("message.find_partner.common_info_employee_KeyNo"),
        // },
        {
          key: "Name",
          label: this.$t("message.find_partner.common_info_employee_Name"),
        },
        {
          key: "Job",
          label: this.$t("message.find_partner.common_info_employee_Job"),
        },
      ],
      invest_list_fields: [
        // {
        //   key: "KeyNo",
        //   label: this.$t("message.find_partner.common_info_invest_list_KeyNo"),
        // },
        {
          key: "RegistCapi",
          label: this.$t(
            "message.find_partner.common_info_invest_list_RegistCapi",
          ),
        },
        {
          key: "StartDate",
          label: this.$t(
            "message.find_partner.common_info_invest_list_StartDate",
          ),
        },
        {
          key: "Status",
          label: this.$t("message.find_partner.common_info_invest_list_Status"),
        },
        {
          key: "OperName",
          label: this.$t(
            "message.find_partner.common_info_invest_list_OperName",
          ),
        },
      ],
      change_list_fields: [
        {
          key: "ProjectName",
          label: this.$t(
            "message.find_partner.common_info_change_list_ProjectName",
          ),
        },
        {
          key: "BeforeList",
          label: this.$t(
            "message.find_partner.common_info_change_list_BeforeList",
          ),
        },
        {
          key: "AfterList",
          label: this.$t(
            "message.find_partner.common_info_change_list_AfterList",
          ),
        },
        {
          key: "ChangeDate",
          label: this.$t(
            "message.find_partner.common_info_change_list_ChangeDate",
          ),
        },
      ],
      branch_list_fields: [
        {
          key: "KeyNo",
          label: this.$t("message.find_partner.common_info_branch_list_KeyNo"),
        },
        {
          key: "Name",
          label: this.$t("message.find_partner.common_info_branch_list_Name"),
        },
        {
          key: "DirectorName",
          label: this.$t(
            "message.find_partner.common_info_branch_list_DirectorName",
          ),
        },
        {
          key: "Status",
          label: this.$t("message.find_partner.common_info_branch_list_Status"),
        },
      ],
      more_email_list_fields: [
        {
          key: "Source",
          label: this.$t(
            "message.find_partner.common_info_more_email_list_Source",
          ),
        },
        {
          key: "Value",
          label: this.$t(
            "message.find_partner.common_info_more_email_list_Value",
          ),
        },
      ],
      more_tel_list_fields: [
        {
          key: "Source",
          label: this.$t(
            "message.find_partner.common_info_more_tel_list_Source",
          ),
        },
        {
          key: "Value",
          label: this.$t(
            "message.find_partner.common_info_more_tel_list_Value",
          ),
        },
      ],
      ent_tag_list_fields: [
        {
          key: "Type",
          label: this.$t("message.find_partner.common_info_ent_tag_list_Type"),
        },
        {
          key: "Name",
          label: this.$t("message.find_partner.common_info_ent_tag_list_Name"),
        },
      ],
      object_table_fields: [
        {
          key: "Key",
          label: this.$t("message.find_partner.table_field"),
        },
        {
          key: "Translated",
          label: this.$t("message.find_partner.table_value"),
        },
        {
          key: "Original",
          label: this.$t("message.find_partner.table_value_cn"),
        },
      ],
    };
  },
  mounted() {
    // this.service_info = Object.entries(this.doc);
    // this.response_info = this.doc;
    // this.service_info_objects = this.service_info.filter(item => typeof item[1] === 'object' && item[1] !== null && !_.isArray(item[1]));
    // this.service_info = this.service_info.filter(item => typeof item[1] !== 'object' && !_.isArray(item[1]));
    setTimeout(() => {
      this.$root.$emit("print-pdf", {
        signature: "",
        type: "company-info-service-cn",
      });
    }, 2000);
  },
  computed: {},
  methods: {
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
    prepareURL(string) {
      let url;
      try {
        url = new URL(string);
      } catch (_) {
        return "https://" + string;
      }
      return string;
    },
    // searchCompanyInfo() {
    //     axios.get(window.base+'/admin/GetBillingServiceInfo?code=430')
    // 		.then(response=>{
    // 			this.$bvModal.msgBoxConfirm(this.$t('message.find_partner.cn_company_info_check_alert') + ' ' + response.data.billing_service_price + ' ' + response.data.billing_service_cur, {
    // 				title: this.$t('message.confirm'),
    // 				size: 'sm',
    // 				buttonSize: 'sm',
    // 				okVariant: 'danger',
    // 				okTitle: this.$t('message.yes'),
    // 				cancelTitle: this.$t('message.no'),
    // 				footerClass: 'p-2',
    // 				hideHeaderClose: false,
    // 				centered: true
    // 				}).then(value => {
    // 					if(value){
    // 						axios.get(window.base + '/library/openAPIQCCMockup?keyWord=' + this.keyWord).then(response => {
    //                         this.searchComplete = true;
    //                         this.service_info = Object.entries(response.data.Result);
    //                         this.response_info = response.data.Result;
    //                         this.service_info_objects = this.service_info.filter(item => typeof item[1] === 'object' && item[1] !== null && !_.isArray(item[1]));

    //                         console.log('service info objects');
    //                         console.log(this.service_info_objects);

    //                         this.service_info = this.service_info.filter(item => typeof item[1] !== 'object' && !_.isArray(item[1]));

    //                         console.log('service info');
    //                         console.log(this.service_info);
    //                     })
    // 					}
    // 				})
    // 		})

    // }
  },
};
</script>
